module.exports = {
    PENDING : "pending",
    REVIEWED : "reviewed",
    APPROVED : "approved",
    REJECTED : "rejected",
    PROCESSING : "processing",
    ADVANCED : "advanced",
    SETTLED : "settled",
    DRAFT : "draft"
};